import {PublishMockInvoiceApiFactory} from "../../../lusca-search-api/LuscaSearchApiFactory";


export const usePublishMockInvoice = () => {
    const publishMockInvoice = async (paymentId: string, paymentDate: string, stage: string) => {
        const publishMockInvoiceApi = PublishMockInvoiceApiFactory();
        return await publishMockInvoiceApi.publishMockAcadiaInvoice(stage, {
            paymentId: paymentId,
            paymentDate: paymentDate
        });
    };

    return { publishMockInvoice };
};